import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/axios.js';
import { toast } from 'react-toastify';



export const addChatbot = createAsyncThunk('addChatbot', async ({ chatbot, projectId }, { rejectWithValue }) => {
    try {
        const res = await api.post('/api/addChatbot', { ...chatbot, projectId });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }

});

export const getChatbots = createAsyncThunk('getChatbots', async ({ projectId }, { rejectWithValue }) => {
    try {
        const url = projectId ? `/api/getChatbots?projectId=${projectId}` : '/api/getChatbots';
        const res = await api.get(url);
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
})

export const updateChatbot = createAsyncThunk('updateChatbot', async ({ id, flow, projectId }, { rejectWithValue }) => {
    try {
        const res = await api.put(`/api/updateChatbot/${id}`, { ...flow, projectId });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
})

export const deleteChatbot = createAsyncThunk('deleteChatbot', async ({ id, projectId }, { rejectWithValue }) => {
    try {
        const res = await api.delete(`/api/deleteChatbot/${id}`, { params: { projectId } });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const updateChatbotName = createAsyncThunk('updateChatbotName', async ({ id, newName, projectId }, { rejectWithValue }) => {
    try {
        const res = await api.put(`/api/updateChatbotName/${id}`, { newName, projectId });
        return res.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});